/**
 * Enrollment invite overlay — disabled.
 * The Forecasting Joyride spotlight returns each browser session until the shop has a chatbot thread.
 */
export function ChatbotBetaBanner() {
  return null;
}

export default ChatbotBetaBanner;
